<app-headline>
  <h1 app-headline-title color="primary">Collars map</h1>
  <div app-headline-actions>
    <button mat-icon-button (click)="refresh()" [disabled]="loading"
            matTooltip="Refresh" aria-label="Refresh collar locations">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</app-headline>

<mat-card>
  @if (error) {
    <div class="map-error" role="alert">{{ error }}</div>
  }
  <ngrx-busy>
    <div class="map-container" [attr.aria-busy]="loading">
      <div #map class="map" role="region" aria-label="Global collar locations"></div>
      <div #countControl class="map-count" role="status" [hidden]="!hasLoaded">
        Collars: <strong>{{ count }}</strong>
      </div>
      @if (!loading && !error && hasLoaded && !count) {
        <div class="map-empty" role="status">No linked collars with known coordinates.</div>
      }
    </div>
  </ngrx-busy>
</mat-card>
